import { createApi } from "@reduxjs/toolkit/dist/query/react"

import { baseQuery } from "../api"
import { getQueryString } from "../../common/utils"
import {
  DEFAULT_PRICING_SET_ENDPOINT,
  PRICING_SET_DETAILS_ENDPOINT,
  PRICING_SET_ENDPOINT
} from "../../common/constants"
import {
  FindPricingSetsResponse,
  FindDefaultPricingSetsResponse
} from "../../types"
import bbApi from "../../api"
import { UpdateProfileOrderPayload } from "../../api/pricing-sets"

const reducerPath = "pricing-sets"

export const pricingSetsApi = createApi({
  reducerPath,
  baseQuery,
  tagTypes: [reducerPath],
  endpoints: builder => ({
    findPricingSets: builder.query({
      query: (params: { [key: string]: number | string }) =>
        `${PRICING_SET_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (responseData: FindPricingSetsResponse) =>
        responseData.sets ?? []
    }),
    findDefaultPricingSets: builder.query({
      query: (params: { [key: string]: number | string }) =>
        `${DEFAULT_PRICING_SET_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (responseData: FindDefaultPricingSetsResponse) =>
        responseData.set_data
    }),
    fetchPricingSetDetails: builder.query({
      query: (params: { [key: string]: number | string }) =>
        `${PRICING_SET_DETAILS_ENDPOINT}${getQueryString(params)}`,
      transformResponse: (responseData: FindDefaultPricingSetsResponse) =>
        responseData.set_data
    }),
    updatePricingSetProfileOrder: builder.mutation({
      queryFn: async (data: UpdateProfileOrderPayload) => {
        const response = await bbApi.pricingSets.updateProfileOrder(data)
        if (response.status === "error") {
          return { error: { status: 200, data: response } }
        }
        return { data: response }
      }
    })
  })
})

export const {
  useFindPricingSetsQuery,
  useFindDefaultPricingSetsQuery,
  useFetchPricingSetDetailsQuery,
  useUpdatePricingSetProfileOrderMutation,
  endpoints: pricingSetsEndpoints
} = pricingSetsApi
